module.exports = __webpack_public_path__ + "img/b-hair4.d2ec410d.png";